// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"suggestion-block_wrapper__2KE8P","text":"suggestion-block_text__LP_Y6"};